import { EventMountArg } from '@fullcalendar/core';
import { luscinia } from '../../luscinia';

export function eventClickHandler(info: EventMountArg, eventRecordUrl: string) {
    if (info['event']._def.ui.startEditable)
    {
        if (!info.el.dataset.modalOpen || info.el.dataset.modalOpen === 'false') {
            info.el.dataset.modalOpen = 'true';
            try {
                luscinia.openCustomModalEdit(eventRecordUrl, info.event._def.publicId, '').then(() => {
                    info.el.dataset.modalOpen = 'false';
                });
            } catch (error) {
                console.error('Error occurred:', error);
            }
        }
    }
}
